import type { ComponentPropsWithoutRef } from 'react';
import { Grid } from '@simplywallst/ui-core';

export const Panel = ({
  borderTopLeftRadius,
  borderTopRightRadius,
  backgroundColor,
  children,
  ...rest
}: ComponentPropsWithoutRef<typeof Grid>) => {
  return (
    <Grid
      borderTopLeftRadius="x2"
      borderTopRightRadius="x2"
      backgroundColor="noir"
      {...rest}
    >
      {children}
    </Grid>
  );
};
